import { PropsWithChildren, useState } from 'react';
import { Drawer } from './style';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Tooltip,
    useTheme,
} from '@mui/material';
import { SVG, sideBarItems } from '../../assets';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { unAuthenticated } from '../../features/isAuth';
interface PropsType extends PropsWithChildren {
    open: boolean;
}

const SideBar: React.FC<PropsType> = ({ open }) => {
    const dispatch = useDispatch();
    const { palette } = useTheme();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [tooltipNumber, setTooltipNumber] = useState(0);
    return (
        <Drawer variant="permanent" open={open}>
            <Stack alignItems={'center'} p={'30px 0'}>
                <SVG width={51} height={43}>
                    <path
                        d="M26.1864 32.87H34.5573C35.7589 32.87 37.7818 32.7079 38.5697 31.6306C38.8652 31.2264 38.9574 30.731 38.9574 30.2395V30.1322C38.9574 29.7297 38.8913 29.3199 38.6923 28.9649C37.9604 27.6616 35.5759 27.5008 34.2878 27.5008H26.1873V32.87H26.1864ZM26.1864 17.7467H32.3579C33.5599 17.7467 35.7102 17.5977 36.5037 16.5195C36.7801 16.1423 36.8657 15.682 36.8657 15.2227V15.1153C36.8657 12.9994 34.5681 12.6987 32.8937 12.6987H26.1864V17.7467ZM19.5265 28.2161C20.6803 28.2161 21.6147 29.1509 21.6147 30.3047C21.6147 31.4576 20.6803 32.3924 19.5265 32.3924C18.3732 32.3924 17.4384 31.4576 17.4384 30.3047C17.4384 29.1509 18.3732 28.2161 19.5265 28.2161ZM15.3411 4.56728C15.7018 4.56728 16.0404 4.65768 16.3372 4.81977C16.6236 4.96536 16.9469 5.0488 17.2906 5.0488C18.4449 5.0488 19.3796 4.11402 19.3796 2.96022C19.3796 2.89286 19.3757 2.8242 19.3692 2.75814V2.7551C19.3631 2.69296 19.3544 2.63211 19.3431 2.57214C19.3362 2.50478 19.3327 2.43655 19.3327 2.36615C19.3327 1.21322 20.2679 0.277138 21.4217 0.277138C22.5747 0.277138 23.5099 1.21322 23.5099 2.36615C23.5099 2.43438 23.5064 2.50304 23.5007 2.5691H34.1266C37.9969 2.5691 42.1406 3.49475 44.9632 6.31733C47.0027 8.35637 47.9605 10.8413 47.9605 13.7212V13.829C47.9605 17.1426 46.7415 19.7227 44.4821 21.6688C48.0209 23.617 50.0521 26.5256 50.0521 31.1499V31.2577C50.0521 33.6036 49.4633 35.8473 48.0683 37.7568C45.0406 41.9023 39.3793 43 34.5573 43H20.8268C19.4257 43 18.1546 42.4963 17.1803 41.658C16.8043 42.2008 16.1764 42.5567 15.4641 42.5567C14.3116 42.5567 13.3768 41.6207 13.3768 40.4677C13.3768 39.3582 14.2412 38.4517 15.3329 38.3831H15.3346C15.3781 38.3813 15.4215 38.3791 15.4641 38.3791C15.538 38.3791 15.6093 38.3831 15.6805 38.39C16.7722 38.3218 17.6379 37.4152 17.6379 36.3053C17.6379 35.1515 16.7031 34.2168 15.5497 34.2168H15.5228C15.4693 34.222 15.4154 34.225 15.3559 34.2259C15.3216 34.2298 15.2864 34.2328 15.2525 34.2389V34.2281C12.8845 34.2281 10.9636 32.3072 10.9636 29.9379C10.9636 27.5686 12.8845 25.6491 15.2525 25.6491C15.3311 25.6491 15.4037 25.6512 15.4693 25.6551C16.521 25.5465 17.341 24.6582 17.341 23.5774C17.341 22.4245 16.4063 21.4897 15.2525 21.4897V21.4715C14.2269 21.3389 13.4351 20.4624 13.4351 19.4011C13.4351 18.3395 14.2269 17.4621 15.2525 17.3295V17.3204L15.3633 17.3187H15.3642C15.408 17.3147 15.4537 17.3134 15.4989 17.3126C17.7535 17.1848 19.5422 15.3174 19.5422 13.0307C19.5422 10.6996 17.6839 8.80311 15.3681 8.7427H15.3411C15.3129 8.7427 15.2846 8.74183 15.2577 8.74097H15.2525C14.1408 8.69447 13.2517 7.77794 13.2517 6.65413C13.2517 5.50076 14.1869 4.56555 15.3411 4.56555V4.56728ZM21.0845 19.3047C21.8902 19.3047 22.5438 19.9578 22.5438 20.764C22.5438 21.5701 21.8902 22.2246 21.0845 22.2246C20.2779 22.2246 19.6243 21.5701 19.6243 20.764C19.6243 19.9578 20.2779 19.3047 21.0845 19.3047Z"
                        fill="#FCFCFC"
                    />
                    <path
                        d="M9.73702 34.7358C10.89 34.7358 11.826 35.6706 11.826 36.8244C11.826 37.9773 10.89 38.9121 9.73702 38.9121C8.58452 38.9121 7.64844 37.9773 7.64844 36.8244C7.64844 35.6706 8.58452 34.7358 9.73702 34.7358Z"
                        fill="#644B98"
                    />
                    <path
                        d="M5.23935 10.7051C6.0455 10.7051 6.69867 11.3595 6.69867 12.1657C6.69867 12.9718 6.0455 13.625 5.23935 13.625C4.43321 13.625 3.77917 12.9718 3.77917 12.1657C3.77917 11.3595 4.43321 10.7051 5.23935 10.7051Z"
                        fill="#BCABFF"
                    />
                    <path
                        d="M12.0228 11.7534C13.1766 11.7534 14.1118 12.6882 14.1118 13.842C14.1118 14.9949 13.1766 15.9297 12.0228 15.9297C10.8703 15.9297 9.93509 14.9949 9.93509 13.842C9.93509 12.6882 10.8703 11.7534 12.0228 11.7534Z"
                        fill="#DDD5FF"
                    />
                    <path
                        d="M7.95921 19.8242C9.80877 19.8242 11.3085 21.3239 11.3085 23.1735C11.3085 25.0226 9.80877 26.5215 7.95921 26.5215C6.10965 26.5215 4.60992 25.0226 4.60992 23.1735C4.60992 21.3239 6.10965 19.8242 7.95921 19.8242Z"
                        fill="#BCABFF"
                    />
                    <path
                        d="M13.4088 -3.33786e-06C14.215 -3.33786e-06 14.869 0.65447 14.869 1.46061C14.869 2.26675 14.215 2.91992 13.4088 2.91992C12.6031 2.91992 11.9495 2.26675 11.9495 1.46061C11.9495 0.65447 12.6031 -3.33786e-06 13.4088 -3.33786e-06Z"
                        fill="#BCABFF"
                    />
                    <path
                        d="M2.08901 15.5904C3.24282 15.5904 4.17803 16.5252 4.17803 17.679C4.17803 18.8328 3.24282 19.7676 2.08901 19.7676C0.936514 19.7676 0 18.8328 0 17.679C0 16.5252 0.936514 15.5904 2.08901 15.5904Z"
                        fill="#FCFCFC"
                    />
                    <path
                        d="M3.92756 28.3721C4.73326 28.3721 5.38687 29.0252 5.38687 29.8314C5.38687 30.6375 4.73326 31.292 3.92756 31.292C3.12055 31.292 2.46738 30.6375 2.46738 29.8314C2.46738 29.0252 3.12055 28.3721 3.92756 28.3721Z"
                        fill="#FCFCFC"
                    />
                </SVG>
            </Stack>
            <List
                sx={{
                    '&& .MuiTypography-root': {
                        fontSize: '1rem',
                    },
                    // selected and (selected + hover) states
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: `${palette.primary.dark}`,
                        // "&, & .MuiListItemIcon-root": {
                        //   color: "pink",
                        // },
                    },
                    // hover states
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: `${palette.primary.light}`,
                    },
                }}>
                {sideBarItems.map(item => (
                    <ListItem
                        key={item.id}
                        disablePadding
                        sx={{ display: 'block' }}>
                        <Tooltip
                            title={item.name}
                            open={!open && item.id === tooltipNumber}
                            onMouseOver={() => setTooltipNumber(item.id)}
                            onMouseLeave={() => setTooltipNumber(-1)}
                            placement={'left'}>
                            <ListItemButton
                                selected={
                                    item.path === `/${pathname.split('/')[1]}`
                                }
                                onClick={() => {
                                    if (item.path === '/signout') {
                                        localStorage.removeItem(
                                            'car-wash-token'
                                        );
                                        dispatch(unAuthenticated());
                                        navigate('/signin');
                                    } else
                                        navigate(item.path ? item.path : '/');
                                }}
                                sx={{
                                    minHeight: 35,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                }}>
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.name}
                                    sx={{ opacity: open ? 1 : 0 }}
                                />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                ))}
            </List>
        </Drawer>
    );
};

export default SideBar;
